module.exports = __webpack_public_path__ + "img/9788952785893.2ac9eb02.jpg";